import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import atsCompanies from 'modules/ats/store/collections/atsCompanies'
import gDPRDataRetentions from 'modules/ats/store/collections/gDPRDataRetentions'

import DataErasure from './DataErasure'
import DataRetention from './DataRetention'
import EmailConsentRenewal from './EmailConsentRenewal'

const DataRetentionSettings = () => {
  const currentRetention = gDPRDataRetentions.current

  const { loading } = useAsyncData(() => {
    return Promise.all([gDPRDataRetentions.fetch(), atsCompanies.fetch()])
  }, [])

  if (loading) {
    return (
      <Box alignItems="center" paddingY="s16">
        <Spinner />
      </Box>
    )
  }

  if (!currentRetention) {
    return null
  }

  return (
    <>
      <DataRetention currentRetention={currentRetention} />
      {currentRetention.attributes.consent_limit_enabled && (
        <>
          <EmailConsentRenewal currentRetention={currentRetention} />
          <DataErasure currentRetention={currentRetention} />
        </>
      )}
    </>
  )
}

export default observer(DataRetentionSettings)
